import { render, staticRenderFns } from "./BusinessApply.vue?vue&type=template&id=1894b6d7&"
import script from "./BusinessApply.vue?vue&type=script&lang=js&"
export * from "./BusinessApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports